import { useQuery } from '@tanstack/react-query'
import { incidentsService } from '../services/incidentsService'
import type { Incident } from '../types/incident.types'

export function useIncidentDetail(id: number | null) {
  return useQuery<Incident>({
    queryKey: ['incident', id],
    queryFn: () => incidentsService.getById(id as number),
    enabled: id != null,
    meta: { silent: true, source: 'useIncidentDetail' },
  })
}
